import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProductAttachmentsMutationVariables = Types.Exact<{
  objects: Array<Types.Product_Attachments_Insert_Input> | Types.Product_Attachments_Insert_Input;
}>;


export type AddProductAttachmentsMutation = { __typename?: 'mutation_root', insert_product_attachments?: { __typename?: 'product_attachments_mutation_response', returning: Array<{ __typename?: 'product_attachments', id: any, product_id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, name?: string | null, description?: string | null, created_at: any, updated_at: any }> } | null };


export const AddProductAttachmentsDocument = gql`
    mutation addProductAttachments($objects: [product_attachments_insert_input!]!) {
  insert_product_attachments(objects: $objects) {
    returning {
      id
      product_id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      name
      description
      created_at
      updated_at
    }
  }
}
    `;
export type AddProductAttachmentsMutationFn = Apollo.MutationFunction<AddProductAttachmentsMutation, AddProductAttachmentsMutationVariables>;

/**
 * __useAddProductAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddProductAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductAttachmentsMutation, { data, loading, error }] = useAddProductAttachmentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddProductAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddProductAttachmentsMutation, AddProductAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductAttachmentsMutation, AddProductAttachmentsMutationVariables>(AddProductAttachmentsDocument, options);
      }
export type AddProductAttachmentsMutationHookResult = ReturnType<typeof useAddProductAttachmentsMutation>;
export type AddProductAttachmentsMutationResult = Apollo.MutationResult<AddProductAttachmentsMutation>;
export type AddProductAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddProductAttachmentsMutation, AddProductAttachmentsMutationVariables>;